import React, {FunctionComponent} from 'react';
import classNames from 'classnames';

type CardTitleProps = {
  wide?: boolean
  className?: string
}

const CardTitle: FunctionComponent<CardTitleProps> = ({className, wide = true, children}) =>
  (
    <div className={classNames(className, 'flex items-center px-5', {'justify-between': wide})}>
      {children}
    </div>
  );

export default CardTitle;
